import { render } from "./ViewPanel.vue?vue&type=template&id=fce8f252&scoped=true&ts=true"
import script from "./ViewPanel.vue?vue&type=script&lang=ts"
export * from "./ViewPanel.vue?vue&type=script&lang=ts"

import "./ViewPanel.vue?vue&type=style&index=0&id=fce8f252&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/apps/builder-legacy/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fce8f252"]])

export default __exports__